import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		linksCollection: [
			//shouldn't do positions in store. Same link can appear in multiple pages, with different positioning in each page.
			//or should we? yeah I think we should. if there are any overrides, we just refrain from using v-for.
			//since v-for creates problems, we can completely disable the store for links, and designate them within components (do this)
			{
				pageName: 'agac',
				pageLinks: [
					{
						linksTo: 'paratoner',
						posX: '10px',
						posY: '20px'
					}, {
						linksTo: 'yaprak',
						posX: '30px',
						posY: '40px'
					}, {
						linksTo: 'dal',
						posX: '50px',
						posY: '60px'
					}, {
						linksTo: 'metin',
						posX: '70px',
						posY: '80px'
					}
				]
			}, {
				pageName: 'metin',
				pageLinks: [
					{
						linksTo: 'kazima',
						posX: '10px',
						posY: '20px'
					},
					{
						linksTo: 'madalyon',
						posX: '30px',
						posY: '40px'
					},
				]
			},
		]
	},
	mutations: {},
	actions: {}
})
